import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TopHeader = () => {
  return (
    <div className="fixed-top" style={{ 
      backgroundColor: '#2E8B57', 
      color: 'white', 
      padding: '8px 0',
      fontSize: '14px',
      zIndex: 1030
    }}>
      <Container>
        <Row className="align-items-center">
          <Col md={8}>
            <span>📧 info@womenshgenterprises.com | 📞 +91-7397382501</span>
          </Col>
          <Col md={4} className="text-end">
            <Link 
              to="/login" 
              className="text-white text-decoration-none me-3 hover-effect"
              style={{ transition: 'opacity 0.3s' }}
              onMouseOver={(e) => e.target.style.opacity = '0.8'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              Feedback
            </Link>
            <Link 
              to="/signup" 
              className="text-white text-decoration-none hover-effect"
              style={{ transition: 'opacity 0.3s' }}
              onMouseOver={(e) => e.target.style.opacity = '0.8'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              Farmer Registration
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TopHeader;